import applicationFormService from '../../services/applicationForm.service';
import { SelectLeaseOptionInput, SelectLeaseOptionResponse } from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import { NetworkError } from '../../state-machine/actions/genericActions';
import { setAppStatusParams } from '../../helpers/url/url.helpers';

const selectLeaseOption = async (context: any, event: any): Promise<SelectLeaseOptionResponse | undefined> => {
  try {
    const input: SelectLeaseOptionInput = {
      applicationId: context.application?.lease?.id,
      leaseTerm: context.customerSelectedLeaseTerm ?? event.data,
    };

    const { data } = await applicationFormService.selectLeaseOption(input);
    setAppStatusParams('docsReady');
    return data?.selectLeaseOption as SelectLeaseOptionResponse;
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};

export default selectLeaseOption;
